// extracted by mini-css-extract-plugin
module.exports = {"imgsWrapper":"styles-module__imgsWrapper___2l8m8","imgWrapper":"styles-module__imgWrapper___Fj6yc","imgIcon":"styles-module__imgIcon___2BpH_"};